export const VIDEOS_COUNT_MOBILE_SLIDER = 8;



// WEBPACK FOOTER //
// ./src/mobile/constants/layout.js